import c from 'classnames';

import { SelectSize } from '../../types';
import { deleteIconSpacing } from './styles';

const CONFIG = {
  large: {
    deleteIcon: 'w-18 h-18',
    root: c('px-8 py-4', deleteIconSpacing(0.8)),
  },
  medium: {
    deleteIcon: 'w-16 h-16',
    root: c('px-8 py-2', deleteIconSpacing(0.4)),
  },
};

export const getClasses = (size: SelectSize) => {
  const config = CONFIG[size];

  return {
    deleteIcon: c('m-0 fill-current text-icon-placeholder', config.deleteIcon),
    label: 'px-0 truncate',
    root: c('h-auto rounded-4 ps-8 pe-6 m-2 max-w-full', config.root),
  };
};
